module.exports = __webpack_public_path__ + "49a931e83323c39d5f3e1de817d896f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/helpers/images/thankYouImage/background-purple.svg
// module id = ./src/helpers/images/thankYouImage/background-purple.svg
// module chunks = 4